import { createSelector } from "reselect";

import { EMPTY_OBJECT } from "lib";
import { getActiveRole, getDeployments } from "./root";

export const getActiveLivestockAgentDeployment = createSelector(
  [getActiveRole, getDeployments],
  (activeRole, deployments) => {
    // Livestock Agents should only have one deployment attached to their role.
    const activeRoleDeploymentId = activeRole?.deployments?.[0]?.id;
    return deployments[activeRoleDeploymentId] || EMPTY_OBJECT;
  },
);
